import { ITradeInState } from '@makemydeal/dr-activities-common';
import { MultiTradeInState } from '../../types/mulitTradeinTypes';
import { getInitialState } from '../reducer';

export const initialtradeInState: ITradeInState = {
    amountOwed: 0,
    condition: '',
    color: '',
    isSkipped: false,
    year: 0,
    make: '',
    makeId: '',
    model: '',
    modelId: '',
    trim: '',
    trimId: '',
    mileage: 0,
    vin: '',
    vehicleId: '',
    source: '',
    status: '',
    expirationDate: '',
    offerDate: '',
    offerId: '',
    ownershipType: '',
    owed: 0,
    value: 0,
    vehicleOptions: {},
    isCompleted: false
};

export const initialMultiTradeInState: MultiTradeInState = {
    activeIndex: 0,
    tradeIns: [
        {
            tradeIn: initialtradeInState,
            tradeInComponent: getInitialState(),
            isExpanded: true
        }
    ]
};

export const getEmptyTradeInItem = () => ({
    tradeIn: initialtradeInState,
    tradeInComponent: getInitialState(),
    isExpanded: true
});
